import { gql } from '@apollo/client';
import { IGadCountry } from '@global/types/types';

export const UPDATE_BILLING_INFORMATION = gql`
  mutation wUpdateBilling(
    $orderUid: String!
    $address: Object!
    $CCname: String!
    $wTOSAccepted: Boolean
  ) {
    wUpdateBilling(
      orderUid: $orderUid
      address: $address
      CCname: $CCname
      wTOSAccepted: $wTOSAccepted
    )
  }
`;

interface Address {
  uid?: string;
  upaLine1: string;
  upaLine2?: string;
  upaCity: string;
  upaPostcode: string;
  upaPhoneNumber: string;
  wCountry: string;
  gadStateOrProvince: string;
  wNewAddress: boolean;
  gadCountry: IGadCountry;
}

export interface UPDATE_BILLING_INFORMATION_VARIABLES {
  orderUid: string;
  address: Address;
  CCname: string;
  wTOSAccepted?: boolean;
}
